<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <!--Project information -->

    <div class="ui vertical basic segment" fxLayout="column" fxLayoutGap="25px">
      <div fxLayout="column">
        <div fxFlex>
          <img
            *ngIf="user.logoPath"
            src="{{ baseUrl }}/public/image/?media={{ user.logoPath }}"
            class="ui mini image"
          />
          <img
            *ngIf="!user.logoPath"
            src="assets/avatar/1.jpg"
            class="ui circular tiny image"
          />
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>NAME</strong></div>
        <div fxFlex>
          {{ user?.firstName }} {{ user?.middleName }} {{ user?.lastName }}
        </div>
      </div>

      <div fxLayout="column">
        <div fxFlex class="header"><strong>USERNAME</strong></div>
        <div fxFlex>{{ user?.username }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex class="header"><strong>NUMBER</strong></div>
        <div fxFlex>{{ user?.mobileNumber }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>EMAIL </strong></div>
        <div fxFlex>{{ user?.appUserEmail }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>ROLE </strong></div>
        <div fxFlex>{{ user?.roleId?.roleName }}</div>
      </div>

      <div fxLayout="column">
        <div fxFlex><strong>DATE CREATED</strong></div>
        <div fxFlex>{{ user?.dateCreated | date: "medium" }}</div>
      </div>
      <div fxLayout="column">
        <div fxFlex><strong>CREATED BY</strong></div>
        <div fxFlex>{{ parseCreator(user?.createdBy) }}</div>
      </div>
      <div fxLayout="column">
        <div fxFlex><strong>TWO FACTOR AUTHENTICATION (2FA)</strong></div>
        <div fxFlex>
          <span class="ui red label" [ngClass]="{ green: user.totpEnabled }">{{
            user?.totpEnabled ? "ACTIVE" : "INACTIVE"
          }}</span>
        </div>
      </div>
      <div fxLayout="column">
        <div fxFlex><strong>STATUS</strong></div>
        <div fxFlex>
          <span class="ui red label" [ngClass]="{ green: user.active }">{{
            user?.active ? "ACTIVE" : "DEACTIVATED"
          }}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <!-- <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="save()"
            autofocus>Done</button> -->
</div>
